module.exports = __webpack_public_path__ + "20250721160708/img/ziyuan.5bb4c406.png";